var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('span',{class:(_vm.style + " badge badge-pill border-3 mr-1 mb-1 text-uppercase")},[_vm._v(_vm._s(_vm.statusText[_vm.task.status]))])])}
var staticRenderFns = []

export { render, staticRenderFns }